export interface CadastroDocument {
  id: string;
  nome_completo: string;
  data_nascimento?: string;
  cpf?: string;
  cnpj?: string;
  telefone?: string;
  ops?: string;
  ifood_uuid?: string;
  nao_aprovado_azumi?: boolean;
  tipo_emissao_nf?: string;
  chave_pix?: string;
  tipo_chave_pix?: string;
  tipo_titularidade_pix?: string;
  ativo?: boolean;
  gateway_pagamento?: string;
  service_city?: ServiceCity;
  created_at?: string;
}

export interface SearchCadastroParams {
  dbName: string;
  telefone?: string;
  cpf?: string;
  cnpj?: string;
}

export interface SearchCadastroResponse {
  cadastro: CadastroDocument[];
  allOps: Array<{ ops: string }>;
}

export interface UpdateCadastroParams {
  dbName: string;
  id: string;
  nome_completo?: string;
  data_nascimento?: string;
  cnpj?: string;
  ops?: string;
  ifood_uuid?: string;
  ativo?: boolean;
  gateway_pagamento?: string;
  service_city?: ServiceCity;
}

export interface CadastroEditFormData {
  nome_completo: string;
  data_nascimento: string;
  cnpj: string;
  ops: string;
  ifood_uuid: string;
  ativo: boolean;
  gateway_pagamento: string;
  service_city: ServiceCity;
}

export const GATEWAYS_PAGAMENTO = ["fitbank", "transfeera"] as const;

/** Município do serviço na NFS-e (doc_cadastro_wts.service_city, default 'emissor'). */
export type ServiceCity = "emissor" | "tomador";

export interface CadastroSearchFormData {
  telefone: string;
  cpfCnpj: string;
}
